export class StockRecommendation {
    brokerageFirm: string | undefined;
    code: string | undefined;
    name: string | undefined;
    targetPrice: number | undefined;
    date: Date | undefined;
    finalClosingPrice: number | undefined;
    finalClosingDate: Date | undefined;
    percentPotential: number | undefined;
    lang: string | undefined;
    country: string | undefined;
    createDate: Date | undefined;
    endDate: Date | undefined;
    startDate: Date | undefined;
    status: boolean | undefined;
    type: string | undefined;
    url: string | undefined;
    commentCount:number | undefined;
}
